import { render, staticRenderFns } from "./InsuranceCaseDetails.vue?vue&type=template&id=463fc261"
import script from "./InsuranceCaseDetails.vue?vue&type=script&lang=js"
export * from "./InsuranceCaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports